<template>
  <section
    class="section -center team"
    :class="{ '-light': bg_color === 'light', '-dark': bg_color === 'dark' }"
  >
    <h2 class="section__title team__title" v-reveal>{{ title }}</h2>
    <p class="section__text" v-html="description" v-reveal="{ delay: 200 }" />
    <a
      :href="btn_link"
      target="_blank"
      v-if="btn_text"
      class="team__button button -right"
      v-reveal="{ delay: 225 }"
    >
      <span>{{ btn_text }}</span>
      <div class="button__icon">
        <Icon id="arrow" />
      </div>
    </a>

    <div class="team__flex">
      <div class="team__card" v-for="member in members" :key="member.flexKey" v-reveal>
        <div
          class="team__card-image"
          :style="{
            backgroundImage: `url(${member.image.md || member.image.sm || 'https://placehold.co/400x400'})`,
          }"
        >
          <a
            :href="`mailto:${member.email}`"
            class="team__card-tag"
            v-if="member.email"
            :title="member.email"
          >
            <Icon id="mail" />
          </a>

          <a
            :href="`tel:${member.phone}`"
            class="team__card-tag -phone"
            v-if="member.phone"
            :title="member.phone"
          >
            <Icon id="phone" />
          </a>
        </div>
        <h3 class="team__card-name">{{ member.name }}</h3>
        <p>{{ member.job_title }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import Icon from '@/components/global/Icon.vue'

export default {
  name: 'SectionTeam',
  components: { Icon },
  props: {
    title: {
      type: String,
      default: 'Title',
    },
    description: {
      type: String,
      default: 'Text',
    },
    bg_color: {
      type: String,
      default: 'light',
    },
    btn_link: {
      type: String,
      default: null,
    },
    btn_text: {
      type: String,
      default: null,
    },
    members: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
